<template>
  <div class="details p-4">
    <div class="d-flex align-items-center justify-content-between">
      <div class="d-flex flex-column align-items-start">
        <div class="title">{{ entity.title }}</div>
      </div>
      <button class="direction-btn" type="button" @click="$emit('get-map-direction')">
        <TheDirectionIcon class="direction-btn__icon" />
        <span class="direction-btn__label">Get Directions</span>
      </button>
    </div>
    <RouterLink v-if="routeTo" class="details-link p-3" :to="routeTo">See Details</RouterLink>
  </div>
</template>

<script>
import { getEntityRoute } from '@/helpers/entityType';

import TheDirectionIcon from '@/components/icons/TheDirectionIcon.vue';

export default {
  name: 'MapWithSearchEntityDetails',
  components: { TheDirectionIcon },
  props: {
    entity: {
      type: Object,
      required: true,
    },
  },
  computed: {
    routeTo() {
      return getEntityRoute(this.entity);
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@/assets/scss/variables-site/variables' as vars;

.details {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 200;
  background-color: vars.$c-total-white;
  transition: all 0.3s linear;

  .title {
    max-width: 75%;
    font-size: 15px;
    font-weight: 600;
    letter-spacing: 0.94px;
    text-transform: uppercase;
    color: vars.$c-dark-gray;
  }

  .direction-btn {
    display: flex;
    flex-direction: column;
    align-items: center;

    &__icon {
      width: 20px;
    }

    &__label {
      margin-top: 5px;
      color: vars.$c-gray-a2;
      font-size: 12px;
      font-weight: 400;
      line-height: 15px;
      white-space: nowrap;
    }
  }

  .details-link {
    display: inline-block;
    width: 100%;
    margin-top: 50px;
    font-size: 15px;
    font-weight: 600;
    letter-spacing: 1px;
    text-align: center;
    text-transform: uppercase;
    color: vars.$c-dark-gray;
    border: 1px solid vars.$c-dark-gray;
    cursor: pointer;

    &:hover {
      color: vars.$c-total-white !important;
      background-color: vars.$c-dark-gray;
    }
  }
}
</style>
